var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 7.49984V5.4165C1.66663 3.3415 3.34163 1.6665 5.41663 1.6665H7.49996",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.6665H14.5833C16.6583 1.6665 18.3333 3.3415 18.3333 5.4165V7.49984",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 13.3335V14.5835C18.3334 16.6585 16.6584 18.3335 14.5834 18.3335H13.3334",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 18.3333H5.41663C3.34163 18.3333 1.66663 16.6583 1.66663 14.5833V12.5",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.9165V12.0832C14.1667 13.7498 13.3334 14.5832 11.6667 14.5832H8.33337C6.66671 14.5832 5.83337 13.7498 5.83337 12.0832V7.9165C5.83337 6.24984 6.66671 5.4165 8.33337 5.4165H11.6667C13.3334 5.4165 14.1667 6.24984 14.1667 7.9165Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 10H4.16663",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scanIcon.9d5ef02ab894fd66f4cb3fc6ab4d1cab.svg";
export { ForwardRef as ReactComponent };